module.exports = __webpack_public_path__ + "media/images/courseware_moodle_courses_icon-c878950727903ef498fece2d2185f215.png";